import { getDarkenColor, getLightenColor } from './'

export default (type, colors) => {
  const styles = {
    default: {
      'button-toolchest__item__icon': {
        customCSS: `
          .button-toolchest__item .button .icon {
            color: ${colors.primary};
          }
          .button-toolchest__item .button .icon:hover,
          .button-toolchest__item .button .icon:active, 
          .button-toolchest__item .button .icon:focus {
            color: ${getDarkenColor(colors.primary, 0.07)};
          }
        `
      },
      'input-group-button__button': {
        borderLeftColor: getDarkenColor(colors.light,0.026),
        customCSS: `
          .input-group-button .button {
            color: ${colors.primary};
          }
          .input-group-button .button:hover,  
          .input-group-button .button:focus {
            color: ${getDarkenColor(colors.primary, 0.07)};
            box-shadow: 1px 1px 0 0 ${getDarkenColor(getLightenColor(colors.secondary, 0.5),0.05)};
          }
          .input-group-button + input {
            border-left-color: ${getDarkenColor(colors.light,0.026)};
          }
        `
      },
      'button-toolchest__button': {
        customCSS: `
          .button-toolchest .button {
            color: ${colors.primary};
            background-color: ${getLightenColor(colors.secondary, 0.5)};
            box-shadow: 1px 1px 0 0 ${colors.offgray_mid};
          }
          .button-toolchest .button:hover, 
          .button-toolchest .button:focus {
            color: ${colors.primary};
            background-color: ${getDarkenColor(getLightenColor(colors.secondary, 0.5), 0.05)};
            box-shadow: 1px 1px 0 0  ${getDarkenColor(colors.offgray_mid, 0.05)};
          }
        `
      },
      'button--white': {
        boxShadow: `1px 1px 0 0 ${getLightenColor(colors.primary, 2)}`,
        customCSS: `
          .button--white {
            color: ${colors.primary};
          }
          .button--white:hover, 
          .button--white:focus {
            color: ${getDarkenColor(colors.primary, 0.07)};
            background-color: ${getLightenColor(colors.secondary, 0.5)};
          }
        `
      },
      'button--highlight': {
        customCSS: `
          .button--highlight {
            box-shadow: 1px 1px 0 0 ${getDarkenColor(colors.primary, 0.07)};
          }
          .button--highlight:hover, 
          .button--highlight:focus {
            background-color: ${getDarkenColor(colors.primary, 0.05)};
            box-shadow: 1px 1px 0 0 ${getDarkenColor(getDarkenColor(colors.primary, 0.07), 0.05)};
          }
        `
      },
      'button--alert-subtle': {
        customCSS: `
          .button--alert-subtle {
            background-color: ${getLightenColor(colors.secondary, 0.5)};
            color: ${getDarkenColor(colors.secondary_dark, 0.23)};
          }
          .button--alert-hover:hover, 
          .button--alert-hover:focus {
            color: ${colors.light};
            box-shadow: 1px 1px 0 0 ${getDarkenColor(colors.info_dark, 0.05)};
          }
        `
      },
      'button--lowlight': {
        customCSS: `
          .button--lowlight {
            background-color: ${getLightenColor(colors.secondary, 0.5)};
          }

          .button--lowlight,
          .button--lowlight:hover, 
          .button--lowlight:focus,
          .button--lowlight.state-loading:after,
          .button--lowlight-alt,
          .button--lowlight-alt:hover,
          .button--lowlight-alt:focus,
          .button--lowlight-alt.state-loading:after {
            color: ${getDarkenColor(colors.secondary_dark, 0.23)};
          }

          .button--lowlight-alt {
            color: ${colors.primary};
          }

          .button--lowlight-alt, 
          .button--lowlight {
            background-color: ${getLightenColor(colors.secondary, 0.5)};
            box-shadow: 1px 1px 0 0 ${colors.offgray_mid};
          }

          .button--lowlight-alt:hover, 
          .button--lowlight-alt:focus, 
          .button--lowlight:hover, 
          .button--lowlight:focus {
            color: ${colors.primary};
            background-color: ${getDarkenColor(getLightenColor(colors.secondary, 0.5), 0.05)};
            box-shadow: 1px 1px 0 0 ${getDarkenColor(colors.offgray_mid, 0.05)};
          }
        `
      }
    },
    type1: {
      'c_button__bordered': {
        borderRadius: 3
      },
      'c_button__bordered--white': {
        color: colors.secondary,
        border: `1px solid ${colors.secondary}`,
        background: colors.light
      },
      'button-toolchest__item__icon': {
        customCSS: `
          .button-toolchest__item .button .icon {
            color: ${colors.primary};
          }
          .button-toolchest__item .button .icon:hover,
          .button-toolchest__item .button .icon:active, 
          .button-toolchest__item .button .icon:focus {
            color: ${getDarkenColor(colors.primary, 0.07)};
          }
        `
      },
      'button-toolchest__button': {
        customCSS: `
          .button-toolchest__item .button {
            color: ${colors.primary};
            background-color: ${getLightenColor(colors.secondary, 0.5)};
            box-shadow: 1px 1px 0 0 ${colors.offgray_mid};
          }
          .button-toolchest .button:hover, 
          .button-toolchest .button:focus {
            color: ${colors.primary};
            background-color: ${getDarkenColor(getLightenColor(colors.secondary, 0.5), 0.05)};
            box-shadow: 1px 1px 0 0  ${getDarkenColor(colors.offgray_mid, 0.05)};
          }
        `
      },
      'input-group-button__button': {
        customCSS: `
          .input-group-button .button {
            color: ${colors.primary};
          }
          .input-group-button .button:hover,  
          .input-group-button .button:focus {
            color: ${colors.primary};
            color: ${getDarkenColor(colors.primary, 0.07)};
          }
        `
      },
      'button--white': {
        boxShadow: `1px 1px 0 0 ${getLightenColor(colors.primary, 2)}`,
        customCSS: `
          .button--white {
            color: ${colors.primary};
          }
          .button--white:hover, 
          .button--white:focus {
            color: ${getDarkenColor(colors.primary, 0.07)};
            background-color: ${getLightenColor(colors.secondary, 0.5)};
          }
        `
      },
      'button--highlight': {
        customCSS: `
          .button--highlight {
            box-shadow: 1px 1px 0 0 ${getDarkenColor(colors.primary, 0.07)};
          }
          .button--highlight:hover, 
          .button--highlight:focus {
            background-color: ${getDarkenColor(colors.primary, 0.05)};
            box-shadow: 1px 1px 0 0 ${getDarkenColor(getDarkenColor(colors.primary, 0.07), 0.05)};
          }
        `
      },
      'button--alert-subtle': {
        customCSS: `
          .button--alert-subtle {
            background-color: ${getLightenColor(colors.secondary, 0.5)};
            color: ${getDarkenColor(colors.secondary_dark, 0.23)};
          }
          .button--alert-hover:hover, 
          .button--alert-hover:focus {
            color: ${colors.light};
            box-shadow: 1px 1px 0 0 ${getDarkenColor(colors.info_dark, 0.05)};
          }
        `
      },
      'button--lowlight': {
        customCSS: `
          .button--lowlight {
            background-color: ${getLightenColor(colors.secondary, 0.5)};
          }

          .button--lowlight,
          .button--lowlight:hover, 
          .button--lowlight:focus,
          .button--lowlight.state-loading:after,
          .button--lowlight-alt,
          .button--lowlight-alt:hover,
          .button--lowlight-alt:focus,
          .button--lowlight-alt.state-loading:after {
            color: ${getDarkenColor(colors.secondary_dark, 0.23)};
          }

          .button--lowlight-alt {
            color: ${colors.primary};
          }

          .button--lowlight-alt, 
          .button--lowlight {
            background-color: ${getLightenColor(colors.secondary, 0.5)};
            box-shadow: 1px 1px 0 0 ${colors.offgray_mid};
          }

          .button--lowlight-alt:hover, 
          .button--lowlight-alt:focus, 
          .button--lowlight:hover, 
          .button--lowlight:focus {
            color: ${colors.primary};
            background-color: ${getDarkenColor(getLightenColor(colors.secondary, 0.5), 0.05)};
            box-shadow: 1px 1px 0 0 ${getDarkenColor(colors.offgray_mid, 0.05)};
          }
        `
      }
    }
  }

  return styles[type]
}


// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/cButton.js